module.exports = __webpack_public_path__ + "img/delivered-icon.09d23f4c.png";